<div class="w-full h-full inline-block align-middle" *ngIf="!countDownComplete">
    <div class="flex justify-center w-full md:mt-11 pb-8">
        <img src="assets/icons/Icons/other-payment-options/masterpass_logo.png" alt="masterpass logo">
    </div>
    <div class="flex justify-center pt-4 pb-6">
        <h3 class="text-center"><b>Please wait while you are redirected to Masterpass<sup>TM</sup></b></h3>
    </div>  
    <div class="flex justify-center pt-4 pb-8">
        <mat-spinner></mat-spinner>
    </div>
    <p class="subtext flex justify-center">Redirecting in <countdown class="text-lg" [config]="config" (event)="onCountDownEvent($event)" style="margin-left: 5px;"></countdown></p>
</div>
<div class="w-full h-full inline-block align-middle" *ngIf="!iframeLoaded && iframePostback">
    <div class="flex justify-center w-full md:mt-11 pb-8">
        <img src="assets/icons/Icons/other-payment-options/masterpass_logo.png" alt="ozow logo">
    </div>
    <div class="flex justify-center pt-4 pb-6">
        <h3 class="text-center"><b>Confirming Transaction Status</b></h3>
    </div>  
    <div class="flex justify-center pt-4 pb-8"> 
        <mat-spinner></mat-spinner>
    </div>
</div>
<iframe name="output_frame" class="external-iframe" src="" [attr.data-loaded]="iframeLoaded && countDownComplete" #output_frame (load)="iframeOnLoad($event)"></iframe>